import { Instance } from 'mobx-state-tree';
import { RouteReversedDtoModelBase } from './RouteReversedDtoModel.base';

/* The TypeScript type of an instance of RouteReversedDtoModel */
export interface RouteReversedDtoModelType extends Instance<typeof RouteReversedDtoModel.Type> {}

/* A graphql query fragment builders for RouteReversedDtoModel */
export { selectFromRouteReversedDto, routeReversedDtoModelPrimitives, RouteReversedDtoModelSelector } from './RouteReversedDtoModel.base';

/**
 * RouteReversedDtoModel
 *
 * Route reversed event
 */
export const RouteReversedDtoModel = RouteReversedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
